import { Box, Button, type ButtonProps } from '@chakra-ui/react';
import { openPdfInNewTab, DocumentType, DocumentComponentProps } from './utils';

type PdfGeneratorButtonProps = {
  documentType: DocumentType;
  label: string;
  data: DocumentComponentProps;
} & ButtonProps;

type DocumentMetadata = {
  documentType: DocumentType;
  documentData: DocumentComponentProps;
};

// Type guard for document metadata
// eslint-disable-next-line react-refresh/only-export-components
export function isDocumentMetadata(
  metadata: Record<string, unknown> | null,
): metadata is DocumentMetadata {
  return (
    metadata !== null &&
    typeof metadata === 'object' &&
    'documentType' in metadata &&
    typeof metadata.documentType === 'string' &&
    'documentData' in metadata &&
    typeof metadata.documentData === 'object' &&
    metadata.documentData !== null
  );
}

export function PdfGeneratorButton({
  documentType,
  label,
  data,
  ...buttonProps
}: PdfGeneratorButtonProps): React.ReactElement {
  const onClick = () => {
    const newWindow = !window.ReactNativeWebView ? window.open('', '_blank') : null;
    void openPdfInNewTab(documentType, data, newWindow);
  };

  return (
    <Box>
      <Button {...buttonProps} onClick={onClick}>
        {label}
      </Button>
    </Box>
  );
}

export default PdfGeneratorButton;
